var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.me && _vm.shopInfo
    ? _c(
        "div",
        { staticClass: "col-md-12 no-padding", attrs: { id: "home" } },
        [
          _c(
            "div",
            { staticClass: "header row no-margin" },
            [
              _vm.device.isMobile
                ? [
                    _c(
                      "div",
                      {
                        staticClass:
                          "left col-6 row align-items-center no-margin"
                      },
                      [
                        _c("div", { staticClass: "col no-padding" }, [
                          _vm.isFreeTrialLive && _vm.isUserOwner
                            ? _c("span", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t(
                                        "apps.installapp.message.freetrialdaysleft",
                                        { days: _vm.getFreeTrialDaysLeft }
                                      )
                                    ) +
                                    "\n          "
                                )
                              ])
                            : _vm._e()
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "right col-6 row align-items-center no-margin text-right"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "col no-padding" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "dropdown no-padding mr-2",
                                staticStyle: { float: "right" }
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn no-bg dropdown-toggle",
                                    attrs: {
                                      id: "dropdownMenuButton",
                                      type: "button",
                                      "data-toggle": "dropdown",
                                      "aria-haspopup": "true",
                                      "aria-expanded": "false"
                                    }
                                  },
                                  [
                                    _c("span", { staticClass: "name" }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.me.email || _vm.me.username
                                          ) +
                                          "\n              "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass: "fas fa-user-circle"
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dropdown-menu dropdown-menu-right",
                                    attrs: {
                                      "aria-labelledby": "dropdownMenuButton"
                                    }
                                  },
                                  [
                                    _vm.me.type == "owner" &&
                                    _vm.billCount &&
                                    _vm.isPricingPayAsYouGo
                                      ? _c(
                                          "router-link",
                                          {
                                            staticClass: "dropdown-item",
                                            attrs: {
                                              to: { name: "BillingServiceUsed" }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "message.billingdashboard"
                                                  )
                                                ) +
                                                "\n                "
                                            ),
                                            _c("i", {
                                              staticClass: "far fa-credit-card"
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        attrs: {
                                          href:
                                            "https://www.treesoft.io/th/manual/introduction",
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fas fa-external-link-alt",
                                          staticStyle: {
                                            position: "relative",
                                            left: "-6px"
                                          }
                                        }),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.$t("message.manual")) +
                                            "\n              "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        attrs: {
                                          href:
                                            "https://www.treesoft.io/th/pricing?ref=app",
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fas fa-external-link-alt",
                                          staticStyle: {
                                            position: "relative",
                                            left: "-6px"
                                          }
                                        }),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t("message.treesoftpricing")
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.me.type == "owner" &&
                                    _vm.isPricingPayAsYouGo
                                      ? _c(
                                          "router-link",
                                          {
                                            staticClass: "dropdown-item",
                                            attrs: {
                                              to: { name: "BillingServiceUsed" }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "far fa-credit-card",
                                              staticStyle: {
                                                position: "relative",
                                                left: "-7px"
                                              }
                                            }),
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "message.billingdashboard"
                                                  )
                                                ) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.me.type == "owner" &&
                                    _vm.isPricingPackage
                                      ? _c(
                                          "router-link",
                                          {
                                            staticClass: "dropdown-item",
                                            attrs: {
                                              to: {
                                                name:
                                                  "BillingPackageServiceUsed"
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fas fa-cloud-upload-alt",
                                              staticStyle: {
                                                position: "relative",
                                                left: "-7px"
                                              }
                                            }),
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "message.billingpackagedashboard"
                                                  )
                                                ) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        on: { click: _vm.logout }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fas fa-power-off",
                                          staticStyle: {
                                            position: "relative",
                                            left: "-6px"
                                          }
                                        }),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.$t("message.logout")) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("DropdownLang", {
                              staticClass: "no-padding mr-4",
                              staticStyle: { float: "right" }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ]
                : [
                    _c(
                      "div",
                      {
                        staticClass:
                          "left col-3 col-sm-6 col-md-6 row align-items-center no-margin"
                      },
                      [
                        _c("div", { staticClass: "col no-padding" }, [
                          _vm.shopInfo
                            ? _c("span", { staticClass: "name" }, [
                                _vm._v(_vm._s(_vm.shopInfo.shop_name))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isFreeTrialLive && _vm.isUserOwner
                            ? _c("span", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t(
                                        "apps.installapp.message.freetrialdaysleft",
                                        { days: _vm.getFreeTrialDaysLeft }
                                      )
                                    ) +
                                    "\n          "
                                )
                              ])
                            : _vm._e()
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "right col-9 col-sm-6 col-md-6 row align-items-center no-margin text-right"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "col no-padding" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "dropdown no-padding mr-2",
                                staticStyle: { float: "right" }
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn no-bg dropdown-toggle",
                                    attrs: {
                                      id: "dropdownMenuButton",
                                      type: "button",
                                      "data-toggle": "dropdown",
                                      "aria-haspopup": "true",
                                      "aria-expanded": "false"
                                    }
                                  },
                                  [
                                    _c("span", { staticClass: "name" }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.me.email || _vm.me.username
                                          ) +
                                          "\n              "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass: "fas fa-user-circle"
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dropdown-menu dropdown-menu-right",
                                    attrs: {
                                      "aria-labelledby": "dropdownMenuButton"
                                    }
                                  },
                                  [
                                    [
                                      _vm.me.type == "owner" &&
                                      _vm.isPricingPayAsYouGo
                                        ? _c(
                                            "router-link",
                                            {
                                              staticClass: "dropdown-item",
                                              attrs: {
                                                to: {
                                                  name: "BillingServiceUsed"
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "far fa-credit-card",
                                                staticStyle: {
                                                  position: "relative",
                                                  left: "-7px"
                                                }
                                              }),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.billingdashboard"
                                                    )
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        : _vm.me.type == "owner" &&
                                          _vm.isPricingPackage
                                        ? _c(
                                            "router-link",
                                            {
                                              staticClass: "dropdown-item",
                                              attrs: {
                                                to: {
                                                  name:
                                                    "BillingPackageServiceUsed"
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fas fa-cloud-upload-alt",
                                                staticStyle: {
                                                  position: "relative",
                                                  left: "-7px"
                                                }
                                              }),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.billingpackagedashboard"
                                                    )
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        on: { click: _vm.logout }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fas fa-power-off",
                                          staticStyle: {
                                            position: "relative",
                                            left: "-6px"
                                          }
                                        }),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.$t("message.logout")) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  ],
                                  2
                                )
                              ]
                            ),
                            _vm._v(" "),
                            [
                              _vm.me.type == "owner" &&
                              _vm.billCount &&
                              _vm.isPricingPayAsYouGo
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "no-padding mr-4",
                                      staticStyle: { float: "right" }
                                    },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          staticClass: "btn no-bg text-white",
                                          attrs: {
                                            to: { name: "BillingServiceUsed" }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "far fa-credit-card"
                                          }),
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "message.billingdashboard"
                                                )
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm.me.type == "owner" && _vm.isPricingPackage
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "no-padding mr-4",
                                      staticStyle: { float: "right" }
                                    },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          staticClass: "btn no-bg text-white",
                                          attrs: {
                                            to: {
                                              name: "BillingPackageServiceUsed"
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fas fa-cloud-upload-alt"
                                          }),
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "message.billingpackagedashboard"
                                                )
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "no-padding mr-4",
                                staticStyle: { float: "right" }
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "btn no-bg text-white",
                                    attrs: {
                                      href:
                                        "https://www.treesoft.io/th/manual/introduction",
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.$t("message.manual")) +
                                        "\n              "
                                    ),
                                    _c("i", {
                                      staticClass: "fas fa-external-link-alt",
                                      staticStyle: { "font-size": "11px" }
                                    })
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isPricingPayAsYouGo
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "no-padding mr-4",
                                    staticStyle: { float: "right" }
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "btn no-bg text-white",
                                        attrs: {
                                          href:
                                            "https://www.treesoft.io/th/pricing?ref=app",
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.$t("message.treesoftpricing")
                                            ) +
                                            "\n              "
                                        ),
                                        _c("i", {
                                          staticClass:
                                            "fas fa-external-link-alt",
                                          staticStyle: { "font-size": "11px" }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("DropdownLang", {
                              staticClass: "no-padding mr-4",
                              staticStyle: { float: "right" }
                            })
                          ],
                          2
                        )
                      ]
                    )
                  ]
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: [
                "apps row justify-content-center",
                { suspended: _vm.isSuspended }
              ]
            },
            [
              _vm.checkAuth({ app_id: 1 })
                ? _c(
                    "div",
                    { staticClass: "col-4 col-sm-3 col-md-2 item" },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              name: _vm.getModuleDefaultLink({
                                appId: 1,
                                permissions: _vm.me.permissions
                              })
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "wraper",
                              style: "background:" + _vm.$t("app.pos.bgcolor")
                            },
                            [_c("i", { class: _vm.$t("app.pos.icon") })]
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.$t("app.pos.title")))])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.checkAuth({ app_id: 5 })
                ? _c(
                    "div",
                    { staticClass: "col-4 col-sm-3 col-md-2 item" },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              name: _vm.getModuleDefaultLink({
                                appId: 5,
                                permissions: _vm.me.permissions
                              })
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "wraper",
                              style: "background:" + _vm.$t("app.sales.bgcolor")
                            },
                            [_c("i", { class: _vm.$t("app.sales.icon") })]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("app.sales.title")))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.checkAuth({ app_id: 4 })
                ? _c(
                    "div",
                    { staticClass: "col-4 col-sm-3 col-md-2 item" },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              name: _vm.getModuleDefaultLink({
                                appId: 4,
                                permissions: _vm.me.permissions
                              })
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "wraper",
                              style:
                                "background:" + _vm.$t("app.purchases.bgcolor")
                            },
                            [_c("i", { class: _vm.$t("app.purchases.icon") })]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("app.purchases.title")))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.checkAuth({ app_id: 6 })
                ? _c(
                    "div",
                    { staticClass: "col-4 col-sm-3 col-md-2 item" },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              name: _vm.getModuleDefaultLink({
                                appId: 6,
                                permissions: _vm.me.permissions
                              })
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "wraper",
                              style:
                                "background:" + _vm.$t("app.expenses.bgcolor")
                            },
                            [_c("i", { class: _vm.$t("app.expenses.icon") })]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("app.expenses.title")))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.checkAuth({ app_id: 14 })
                ? _c(
                    "div",
                    { staticClass: "col-4 col-sm-3 col-md-2 item" },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              name: _vm.getModuleDefaultLink({
                                appId: 14,
                                permissions: _vm.me.permissions
                              })
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "wraper",
                              style:
                                "background:" + _vm.$t("app.payroll.bgcolor")
                            },
                            [_c("i", { class: _vm.$t("app.payroll.icon") })]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("app.payroll.title")))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.checkAuth({ app_id: 12 })
                ? _c(
                    "div",
                    { staticClass: "col-4 col-sm-3 col-md-2 item" },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              name: _vm.getModuleDefaultLink({
                                appId: 12,
                                permissions: _vm.me.permissions
                              })
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "wraper",
                              style:
                                "background:" + _vm.$t("app.accounts.bgcolor")
                            },
                            [_c("i", { class: _vm.$t("app.accounts.icon") })]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("app.accounts.title")))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.checkAuth({ app_id: 3 })
                ? _c(
                    "div",
                    { staticClass: "col-4 col-sm-3 col-md-2 item" },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: Object.assign({}, _vm.defaultLinkInventory)
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "wraper",
                              style:
                                "background:" + _vm.$t("app.inventory.bgcolor")
                            },
                            [
                              _c("i", { class: _vm.$t("app.inventory.icon") }),
                              _vm._v(" "),
                              _vm.$store.state.app.loading &&
                              _vm.warehouses.length == 0
                                ? _c("div", { staticClass: "loading" }, [
                                    _c("i", {
                                      staticClass: "fas fa-spinner spin"
                                    })
                                  ])
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("app.inventory.title")))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.checkAuth({ app_id: 13 })
                ? _c(
                    "div",
                    { staticClass: "col-4 col-sm-3 col-md-2 item" },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              name: _vm.getModuleDefaultLink({
                                appId: 13,
                                permissions: _vm.me.permissions
                              })
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "wraper",
                              style: "background:" + _vm.$t("app.hrm.bgcolor")
                            },
                            [_c("i", { class: _vm.$t("app.hrm.icon") })]
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.$t("app.hrm.title")))])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.checkAuth({ app_id: 11 })
                ? _c(
                    "div",
                    { staticClass: "col-4 col-sm-3 col-md-2 item" },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              name: _vm.getModuleDefaultLink({
                                appId: 11,
                                permissions: _vm.me.permissions
                              })
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "wraper",
                              style:
                                "background:" + _vm.$t("app.contacts.bgcolor")
                            },
                            [_c("i", { class: _vm.$t("app.contacts.icon") })]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("app.contacts.title")))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.checkAuth({ app_id: 2 })
                ? _c(
                    "div",
                    {
                      staticClass: "col-4 col-sm-3 col-md-2 item",
                      attrs: { "data-v-step": "appid2" }
                    },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              name: _vm.getModuleDefaultLink({
                                appId: 2,
                                permissions: _vm.me.permissions
                              })
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "wraper",
                              style:
                                "background:" + _vm.$t("app.products.bgcolor")
                            },
                            [_c("i", { class: _vm.$t("app.products.icon") })]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("app.products.title")))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.checkAuth({ app_id: 8 })
                ? _c(
                    "div",
                    { staticClass: "col-4 col-sm-3 col-md-2 item" },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              name: _vm.getModuleDefaultLink({
                                appId: 8,
                                permissions: _vm.me.permissions
                              })
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "wraper",
                              style:
                                "background:" + _vm.$t("app.reports.bgcolor")
                            },
                            [_c("i", { class: _vm.$t("app.reports.icon") })]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("app.reports.title")))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.me.type == "owner" && _vm.isPricingPayAsYouGo
                ? _c(
                    "div",
                    {
                      staticClass: "col-4 col-sm-3 col-md-2 item",
                      attrs: { "data-v-step": "install-app" }
                    },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "AppsCategoryAll" } } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "wraper",
                              style:
                                "background:" + _vm.$t("app.installapp.bgcolor")
                            },
                            [_c("i", { class: _vm.$t("app.installapp.icon") })]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("app.installapp.title")))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.me.type == "owner"
                ? _c(
                    "div",
                    { staticClass: "col-4 col-sm-3 col-md-2 item" },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "SettingsCompany" } } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "wraper",
                              style:
                                "background:" + _vm.$t("app.settings.bgcolor")
                            },
                            [_c("i", { class: _vm.$t("app.settings.icon") })]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("app.settings.title")))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("BaseModalAckFreeTrialEnded", {
            attrs: { id: _vm.MODAL_ACK_FREE_TRIAL },
            on: { onClose: _vm.handleCloseAckFreeTrialEnded }
          }),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              attrs: {
                id: "welcome-modal",
                size: "lg",
                okOnly: "",
                noFade: "",
                hideHeader: "",
                hideHeaderClose: "",
                noCloseOnBackdrop: ""
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "modal-footer",
                    fn: function(ref) {
                      var ok = ref.ok
                      var cancel = ref.cancel
                      var hide = ref.hide
                      return [
                        _c("div", { staticClass: "footer" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-web",
                              on: {
                                click: function($event) {
                                  return _vm.handleClickGetStarted(ok)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("button.getstarted")) +
                                  "\n        "
                              )
                            ]
                          )
                        ])
                      ]
                    }
                  }
                ],
                null,
                false,
                2566903652
              )
            },
            [
              _c(
                "div",
                {
                  staticClass: "d-flex flex-column",
                  staticStyle: { gap: "20px", "font-size": "20px" }
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 mb-3" }, [
                      _c("strong", {
                        domProps: { innerHTML: _vm._s(_vm.welcomeheader) }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "col-12",
                      class: [{ "mb-3": !_vm.isShowYoutubeVideo }],
                      domProps: { innerHTML: _vm._s(_vm.welcomemessage) }
                    }),
                    _vm._v(" "),
                    _vm.isShowYoutubeVideo
                      ? _c("div", { staticClass: "col-12 my-4" }, [
                          _c(
                            "div",
                            {
                              staticClass: "d-flex mw-100",
                              staticStyle: { "overflow-x": "auto", gap: "10px" }
                            },
                            [
                              _c("iframe", {
                                attrs: {
                                  width: "300",
                                  height: "168.75",
                                  src:
                                    "https://www.youtube.com/embed/9SSbmIW9e6A",
                                  title: "YouTube video player",
                                  frameborder: "0",
                                  allow:
                                    "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                                  referrerpolicy:
                                    "strict-origin-when-cross-origin",
                                  allowfullscreen: ""
                                }
                              }),
                              _vm._v(" "),
                              _c("iframe", {
                                attrs: {
                                  width: "300",
                                  height: "168.75",
                                  src:
                                    "https://www.youtube.com/embed/dCEuSH6bD5M",
                                  title: "YouTube video player",
                                  frameborder: "0",
                                  allow:
                                    "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                                  referrerpolicy:
                                    "strict-origin-when-cross-origin",
                                  allowfullscreen: ""
                                }
                              }),
                              _vm._v(" "),
                              _c("iframe", {
                                attrs: {
                                  width: "300",
                                  height: "168.75",
                                  src:
                                    "https://www.youtube.com/embed/AwtvVzTZtIs",
                                  title: "YouTube video player",
                                  frameborder: "0",
                                  allow:
                                    "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                                  referrerpolicy:
                                    "strict-origin-when-cross-origin",
                                  allowfullscreen: ""
                                }
                              }),
                              _vm._v(" "),
                              _c("iframe", {
                                attrs: {
                                  width: "300",
                                  height: "168.75",
                                  src:
                                    "https://www.youtube.com/embed/PRXIAJTk28Q",
                                  title: "YouTube video player",
                                  frameborder: "0",
                                  allow:
                                    "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                                  referrerpolicy:
                                    "strict-origin-when-cross-origin",
                                  allowfullscreen: ""
                                }
                              }),
                              _vm._v(" "),
                              _c("iframe", {
                                attrs: {
                                  width: "300",
                                  height: "168.75",
                                  src:
                                    "https://www.youtube.com/embed/xg3xcZQP9Zc",
                                  title: "YouTube video player",
                                  frameborder: "0",
                                  allow:
                                    "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                                  referrerpolicy:
                                    "strict-origin-when-cross-origin",
                                  allowfullscreen: ""
                                }
                              })
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "col-12 mb-1",
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("message.contactus"))
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 d-flex" }, [
                      _c("div", { staticClass: "mr-2" }, [
                        _c("i", {
                          staticClass: "fas fa-envelope",
                          staticStyle: { color: "#aaa" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", [_vm._v("contact@treesoft.io")])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 d-flex" }, [
                      _c("div", { staticClass: "mr-2" }, [
                        _c("i", {
                          staticClass: "fab fa-youtube",
                          staticStyle: { color: "#FF0000" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", [_vm._v("TreeSoft Official")])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 d-flex" }, [
                      _c("div", { staticClass: "mr-2" }, [
                        _c("i", {
                          staticClass: "fab fa-line",
                          staticStyle: { color: "#00C300" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", [_vm._v("@treesoft")])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 d-flex" }, [
                      _c("div", { staticClass: "mr-2" }, [
                        _c("i", {
                          staticClass: "fab fa-facebook-square",
                          staticStyle: { color: "#1877F2" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", [_vm._v("TreeSoft.io")])
                    ])
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("BaseModalGetDiscount", {
            on: {
              onSubmit: function($event) {
                return _vm.gotoGoogleForm()
              }
            }
          }),
          _vm._v(" "),
          _c("v-tour", {
            staticClass: "tour_install_apps_first",
            attrs: {
              name: "tour_install_apps_first",
              steps: _vm.tourSteps,
              options: _vm.tourOptions,
              callbacks: {
                onFinish: function() {
                  return _vm.onFinishTour["tour_install_apps_first"]()
                }
              }
            }
          }),
          _vm._v(" "),
          _c("v-tour", {
            attrs: {
              name: "tour_install_app_product_first",
              steps: _vm.tourSteps,
              options: _vm.tourOptions,
              callbacks: {
                onFinish: function() {
                  return _vm.onFinishTour["tour_install_app_product_first"]()
                }
              }
            }
          }),
          _vm._v(" "),
          _c("v-tour", {
            attrs: {
              name: "tour_create_product_first",
              steps: _vm.tourSteps,
              options: _vm.tourOptions,
              callbacks: {
                onFinish: function() {
                  return _vm.onFinishTour["tour_create_product_first"]()
                }
              }
            }
          }),
          _vm._v(" "),
          _c("v-tour", {
            attrs: {
              name: "tour_ready_to_use_treesoft",
              steps: _vm.tourSteps,
              options: _vm.tourOptions,
              callbacks: {
                onFinish: function() {
                  return _vm.onFinishTour["tour_ready_to_use_treesoft"]()
                }
              }
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74b1de62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74b1de62","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Home.vue
// module id = null
// module chunks = 